import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _e8ad238a = () => interopDefault(import('../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _5e11cbc8 = () => interopDefault(import('../pages/carbonless.vue' /* webpackChunkName: "pages/carbonless" */))
const _0d9c948a = () => interopDefault(import('../pages/cookie-notice.vue' /* webpackChunkName: "pages/cookie-notice" */))
const _51e44c64 = () => interopDefault(import('../pages/e2e-login.vue' /* webpackChunkName: "pages/e2e-login" */))
const _108b003c = () => interopDefault(import('../pages/error.vue' /* webpackChunkName: "pages/error" */))
const _3d04ffb2 = () => interopDefault(import('../pages/hot.vue' /* webpackChunkName: "pages/hot" */))
const _6bf6f5d4 = () => interopDefault(import('../pages/identity.vue' /* webpackChunkName: "pages/identity" */))
const _4bb20c44 = () => interopDefault(import('../pages/qrCode.vue' /* webpackChunkName: "pages/qrCode" */))
const _41c65634 = () => interopDefault(import('../pages/sales.vue' /* webpackChunkName: "pages/sales" */))
const _2f9e42d8 = () => interopDefault(import('../pages/series-insight.vue' /* webpackChunkName: "pages/series-insight" */))
const _d9f9f28e = () => interopDefault(import('../pages/settings.vue' /* webpackChunkName: "pages/settings" */))
const _403777a4 = () => interopDefault(import('../pages/spotlight.vue' /* webpackChunkName: "pages/spotlight" */))
const _36a2f086 = () => interopDefault(import('../pages/sustainability.vue' /* webpackChunkName: "pages/sustainability" */))
const _c9cdd13e = () => interopDefault(import('../pages/bsx/assets.vue' /* webpackChunkName: "pages/bsx/assets" */))
const _49ad014e = () => interopDefault(import('../pages/bsx/claim.vue' /* webpackChunkName: "pages/bsx/claim" */))
const _6cb8e05a = () => interopDefault(import('../pages/bsx/create.vue' /* webpackChunkName: "pages/bsx/create" */))
const _5b363b8a = () => interopDefault(import('../pages/bsx/incomingOffers.vue' /* webpackChunkName: "pages/bsx/incomingOffers" */))
const _25caab75 = () => interopDefault(import('../pages/bsx/offers.vue' /* webpackChunkName: "pages/bsx/offers" */))
const _3fd1979e = () => interopDefault(import('../pages/bsx/stats.vue' /* webpackChunkName: "pages/bsx/stats" */))
const _0adccc00 = () => interopDefault(import('../pages/bsx/waifu.vue' /* webpackChunkName: "pages/bsx/waifu" */))
const _08e2dbdc = () => interopDefault(import('../pages/ksm/create.vue' /* webpackChunkName: "pages/ksm/create" */))
const _7b1cba91 = () => interopDefault(import('../pages/rmrk/create.vue' /* webpackChunkName: "pages/rmrk/create" */))
const _7cb59392 = () => interopDefault(import('../pages/rmrk/mint.vue' /* webpackChunkName: "pages/rmrk/mint" */))
const _6ee25e2a = () => interopDefault(import('../pages/snek/assets.vue' /* webpackChunkName: "pages/snek/assets" */))
const _e59622f8 = () => interopDefault(import('../pages/snek/claim.vue' /* webpackChunkName: "pages/snek/claim" */))
const _cba2cc38 = () => interopDefault(import('../pages/snek/create.vue' /* webpackChunkName: "pages/snek/create" */))
const _1bf571c5 = () => interopDefault(import('../pages/snek/incomingOffers.vue' /* webpackChunkName: "pages/snek/incomingOffers" */))
const _534064ff = () => interopDefault(import('../pages/snek/offers.vue' /* webpackChunkName: "pages/snek/offers" */))
const _239f2167 = () => interopDefault(import('../pages/snek/stats.vue' /* webpackChunkName: "pages/snek/stats" */))
const _708e77c3 = () => interopDefault(import('../pages/stmn/create.vue' /* webpackChunkName: "pages/stmn/create" */))
const _3c9bb912 = () => interopDefault(import('../pages/stmn/waifu.vue' /* webpackChunkName: "pages/stmn/waifu" */))
const _ec1a661a = () => interopDefault(import('../pages/blog/_slug.vue' /* webpackChunkName: "pages/blog/_slug" */))
const _98173ca8 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _41bb4ace = () => interopDefault(import('../pages/_prefix/index.vue' /* webpackChunkName: "pages/_prefix/index" */))
const _6da5f6e3 = () => interopDefault(import('../pages/_prefix/drops/index.vue' /* webpackChunkName: "pages/_prefix/drops/index" */))
const _af36eb5c = () => interopDefault(import('../pages/_prefix/explore/index.vue' /* webpackChunkName: "pages/_prefix/explore/index" */))
const _232c4d0d = () => interopDefault(import('../pages/_prefix/massmint/index.vue' /* webpackChunkName: "pages/_prefix/massmint/index" */))
const _25bc695f = () => interopDefault(import('../pages/_prefix/teleport.vue' /* webpackChunkName: "pages/_prefix/teleport" */))
const _9c4c6bc2 = () => interopDefault(import('../pages/_prefix/transfer.vue' /* webpackChunkName: "pages/_prefix/transfer" */))
const _0bc15ef2 = () => interopDefault(import('../pages/_prefix/drops/dot-drop.vue' /* webpackChunkName: "pages/_prefix/drops/dot-drop" */))
const _2eaaa841 = () => interopDefault(import('../pages/_prefix/drops/free-drop.vue' /* webpackChunkName: "pages/_prefix/drops/free-drop" */))
const _5e041da7 = () => interopDefault(import('../pages/_prefix/explore/collectibles.vue' /* webpackChunkName: "pages/_prefix/explore/collectibles" */))
const _59f22240 = () => interopDefault(import('../pages/_prefix/explore/items.vue' /* webpackChunkName: "pages/_prefix/explore/items" */))
const _3c7b6670 = () => interopDefault(import('../pages/_prefix/massmint/onboarding.vue' /* webpackChunkName: "pages/_prefix/massmint/onboarding" */))
const _80397c80 = () => interopDefault(import('../pages/_prefix/collection/_id/index.vue' /* webpackChunkName: "pages/_prefix/collection/_id/index" */))
const _14ad2433 = () => interopDefault(import('../pages/_prefix/detail/_id/index.vue' /* webpackChunkName: "pages/_prefix/detail/_id/index" */))
const _48282288 = () => interopDefault(import('../pages/_prefix/gallery/_id/index.vue' /* webpackChunkName: "pages/_prefix/gallery/_id/index" */))
const _bc7e4fc8 = () => interopDefault(import('../pages/_prefix/u/_id.vue' /* webpackChunkName: "pages/_prefix/u/_id" */))
const _7f6d1f11 = () => interopDefault(import('../pages/_prefix/collection/_id/activity.vue' /* webpackChunkName: "pages/_prefix/collection/_id/activity" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/blog",
    component: _e8ad238a,
    name: "blog"
  }, {
    path: "/carbonless",
    component: _5e11cbc8,
    name: "carbonless"
  }, {
    path: "/cookie-notice",
    component: _0d9c948a,
    name: "cookie-notice"
  }, {
    path: "/e2e-login",
    component: _51e44c64,
    name: "e2e-login"
  }, {
    path: "/error",
    component: _108b003c,
    name: "error"
  }, {
    path: "/hot",
    component: _3d04ffb2,
    name: "hot"
  }, {
    path: "/identity",
    component: _6bf6f5d4,
    name: "identity"
  }, {
    path: "/qrCode",
    component: _4bb20c44,
    name: "qrCode"
  }, {
    path: "/sales",
    component: _41c65634,
    name: "sales"
  }, {
    path: "/series-insight",
    component: _2f9e42d8,
    name: "series-insight"
  }, {
    path: "/settings",
    component: _d9f9f28e,
    name: "settings"
  }, {
    path: "/spotlight",
    component: _403777a4,
    name: "spotlight"
  }, {
    path: "/sustainability",
    component: _36a2f086,
    name: "sustainability"
  }, {
    path: "/bsx/assets",
    component: _c9cdd13e,
    name: "bsx-assets"
  }, {
    path: "/bsx/claim",
    component: _49ad014e,
    name: "bsx-claim"
  }, {
    path: "/bsx/create",
    component: _6cb8e05a,
    name: "bsx-create"
  }, {
    path: "/bsx/incomingOffers",
    component: _5b363b8a,
    name: "bsx-incomingOffers"
  }, {
    path: "/bsx/offers",
    component: _25caab75,
    name: "bsx-offers"
  }, {
    path: "/bsx/stats",
    component: _3fd1979e,
    name: "bsx-stats"
  }, {
    path: "/bsx/waifu",
    component: _0adccc00,
    name: "bsx-waifu"
  }, {
    path: "/ksm/create",
    component: _08e2dbdc,
    name: "ksm-create"
  }, {
    path: "/rmrk/create",
    component: _7b1cba91,
    name: "rmrk-create"
  }, {
    path: "/rmrk/mint",
    component: _7cb59392,
    name: "rmrk-mint"
  }, {
    path: "/snek/assets",
    component: _6ee25e2a,
    name: "snek-assets"
  }, {
    path: "/snek/claim",
    component: _e59622f8,
    name: "snek-claim"
  }, {
    path: "/snek/create",
    component: _cba2cc38,
    name: "snek-create"
  }, {
    path: "/snek/incomingOffers",
    component: _1bf571c5,
    name: "snek-incomingOffers"
  }, {
    path: "/snek/offers",
    component: _534064ff,
    name: "snek-offers"
  }, {
    path: "/snek/stats",
    component: _239f2167,
    name: "snek-stats"
  }, {
    path: "/stmn/create",
    component: _708e77c3,
    name: "stmn-create"
  }, {
    path: "/stmn/waifu",
    component: _3c9bb912,
    name: "stmn-waifu"
  }, {
    path: "/blog/:slug",
    component: _ec1a661a,
    name: "blog-slug"
  }, {
    path: "/",
    component: _98173ca8,
    name: "index"
  }, {
    path: "/:prefix",
    component: _41bb4ace,
    name: "prefix"
  }, {
    path: "/:prefix/drops",
    component: _6da5f6e3,
    name: "prefix-drops"
  }, {
    path: "/:prefix/explore",
    component: _af36eb5c,
    name: "prefix-explore"
  }, {
    path: "/:prefix/massmint",
    component: _232c4d0d,
    name: "prefix-massmint"
  }, {
    path: "/:prefix/teleport",
    component: _25bc695f,
    name: "prefix-teleport"
  }, {
    path: "/:prefix/transfer",
    component: _9c4c6bc2,
    name: "prefix-transfer"
  }, {
    path: "/:prefix/drops/dot-drop",
    component: _0bc15ef2,
    name: "prefix-drops-dot-drop"
  }, {
    path: "/:prefix/drops/free-drop",
    component: _2eaaa841,
    name: "prefix-drops-free-drop"
  }, {
    path: "/:prefix/explore/collectibles",
    component: _5e041da7,
    name: "prefix-explore-collectibles"
  }, {
    path: "/:prefix/explore/items",
    component: _59f22240,
    name: "prefix-explore-items"
  }, {
    path: "/:prefix/massmint/onboarding",
    component: _3c7b6670,
    name: "prefix-massmint-onboarding"
  }, {
    path: "/:prefix/collection/:id",
    component: _80397c80,
    name: "prefix-collection-id"
  }, {
    path: "/:prefix/detail/:id",
    component: _14ad2433,
    name: "prefix-detail-id"
  }, {
    path: "/:prefix/gallery/:id",
    component: _48282288,
    name: "prefix-gallery-id"
  }, {
    path: "/:prefix/u/:id?",
    component: _bc7e4fc8,
    name: "prefix-u-id"
  }, {
    path: "/:prefix/collection/:id?/activity",
    component: _7f6d1f11,
    name: "prefix-collection-id-activity"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
